/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LayoutTripsIndexRouteImport } from './routes/_layout/trips/index'
import { Route as LayoutStopsIndexRouteImport } from './routes/_layout/stops/index'
import { Route as LayoutStationsIndexRouteImport } from './routes/_layout/stations/index'
import { Route as LayoutRoutesIndexRouteImport } from './routes/_layout/routes/index'
import { Route as LayoutExportIndexRouteImport } from './routes/_layout/export/index'
import { Route as LayoutTripsTableRouteImport } from './routes/_layout/trips/table'
import { Route as LayoutStopsTableRouteImport } from './routes/_layout/stops/table'
import { Route as LayoutStopsMapRouteImport } from './routes/_layout/stops/map'
import { Route as LayoutStationsTableRouteImport } from './routes/_layout/stations/table'
import { Route as LayoutStationsPathwaysRouteImport } from './routes/_layout/stations/pathways'
import { Route as LayoutStationsPartsRouteImport } from './routes/_layout/stations/parts'
import { Route as LayoutStationsMapRouteImport } from './routes/_layout/stations/map'
import { Route as LayoutStationsInfoRouteImport } from './routes/_layout/stations/info'
import { Route as LayoutStationsFlowRouteImport } from './routes/_layout/stations/flow'
import { Route as LayoutRoutesTripsRouteImport } from './routes/_layout/routes/trips'
import { Route as LayoutRoutesTableRouteImport } from './routes/_layout/routes/table'
import { Route as LayoutRoutesServiceRouteImport } from './routes/_layout/routes/service'
import { Route as LayoutRoutesMapRouteImport } from './routes/_layout/routes/map'
import { Route as LayoutRoutesInfoRouteImport } from './routes/_layout/routes/info'
import { Route as LayoutTripsTripsRoutesIndexRouteImport } from './routes/_layout/trips/trips-routes/index'
import { Route as LayoutTripsTripsRoutesTableRouteImport } from './routes/_layout/trips/trips-routes/table'
import { Route as LayoutStationsStationStationIdRouteImport } from './routes/_layout/stations/station/$stationId'
import { Route as LayoutStationsPathwaysFlowRouteImport } from './routes/_layout/stations/pathways/flow'
import { Route as LayoutStationsPartsTableRouteImport } from './routes/_layout/stations/parts/table'
import { Route as LayoutStationsPartsMapRouteImport } from './routes/_layout/stations/parts/map'
import { Route as LayoutRoutesRouteRouteIdRouteImport } from './routes/_layout/routes/route/$routeId'
import { Route as LayoutStationsStationStationIdIndexRouteImport } from './routes/_layout/stations/station/$stationId/index'
import { Route as LayoutStationsPathwaysFlowIndexRouteImport } from './routes/_layout/stations/pathways/flow/index'
import { Route as LayoutRoutesRouteRouteIdIndexRouteImport } from './routes/_layout/routes/route/$routeId/index'
import { Route as LayoutStationsStationStationIdPartsRouteImport } from './routes/_layout/stations/station/$stationId/parts'
import { Route as LayoutStationsStationStationIdInfoRouteImport } from './routes/_layout/stations/station/$stationId/info'
import { Route as LayoutStationsPathwaysTableStartRouteImport } from './routes/_layout/stations/pathways/table/start'
import { Route as LayoutStationsPathwaysTableEndRouteImport } from './routes/_layout/stations/pathways/table/end'
import { Route as LayoutStationsPathwaysMapTimeIntervalRouteImport } from './routes/_layout/stations/pathways/map/timeInterval'
import { Route as LayoutStationsPathwaysMapPathwayTypesRouteImport } from './routes/_layout/stations/pathways/map/pathwayTypes'
import { Route as LayoutStationsPathwaysMapDirectionalRouteImport } from './routes/_layout/stations/pathways/map/directional'
import { Route as LayoutStationsPathwaysFlowRadialRouteImport } from './routes/_layout/stations/pathways/flow/radial'
import { Route as LayoutStationsPathwaysFlowColumnRouteImport } from './routes/_layout/stations/pathways/flow/column'
import { Route as LayoutRoutesRouteRouteIdTripsRouteImport } from './routes/_layout/routes/route/$routeId/trips'
import { Route as LayoutRoutesRouteRouteIdInfoRouteImport } from './routes/_layout/routes/route/$routeId/info'
import { Route as LayoutStationsStationStationIdPartsIndexRouteImport } from './routes/_layout/stations/station/$stationId/parts/index'

const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutTripsIndexRoute = LayoutTripsIndexRouteImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStopsIndexRoute = LayoutStopsIndexRouteImport.update({
  id: '/stops/',
  path: '/stops/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsIndexRoute = LayoutStationsIndexRouteImport.update({
  id: '/stations/',
  path: '/stations/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoutesIndexRoute = LayoutRoutesIndexRouteImport.update({
  id: '/routes/',
  path: '/routes/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutExportIndexRoute = LayoutExportIndexRouteImport.update({
  id: '/export/',
  path: '/export/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTripsTableRoute = LayoutTripsTableRouteImport.update({
  id: '/trips/table',
  path: '/trips/table',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/trips/table.lazy').then((d) => d.Route),
)
const LayoutStopsTableRoute = LayoutStopsTableRouteImport.update({
  id: '/stops/table',
  path: '/stops/table',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStopsMapRoute = LayoutStopsMapRouteImport.update({
  id: '/stops/map',
  path: '/stops/map',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsTableRoute = LayoutStationsTableRouteImport.update({
  id: '/stations/table',
  path: '/stations/table',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsPathwaysRoute = LayoutStationsPathwaysRouteImport.update({
  id: '/stations/pathways',
  path: '/stations/pathways',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsPartsRoute = LayoutStationsPartsRouteImport.update({
  id: '/stations/parts',
  path: '/stations/parts',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsMapRoute = LayoutStationsMapRouteImport.update({
  id: '/stations/map',
  path: '/stations/map',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsInfoRoute = LayoutStationsInfoRouteImport.update({
  id: '/stations/info',
  path: '/stations/info',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStationsFlowRoute = LayoutStationsFlowRouteImport.update({
  id: '/stations/flow',
  path: '/stations/flow',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoutesTripsRoute = LayoutRoutesTripsRouteImport.update({
  id: '/routes/trips',
  path: '/routes/trips',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoutesTableRoute = LayoutRoutesTableRouteImport.update({
  id: '/routes/table',
  path: '/routes/table',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoutesServiceRoute = LayoutRoutesServiceRouteImport.update({
  id: '/routes/service',
  path: '/routes/service',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoutesMapRoute = LayoutRoutesMapRouteImport.update({
  id: '/routes/map',
  path: '/routes/map',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoutesInfoRoute = LayoutRoutesInfoRouteImport.update({
  id: '/routes/info',
  path: '/routes/info',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTripsTripsRoutesIndexRoute =
  LayoutTripsTripsRoutesIndexRouteImport.update({
    id: '/trips/trips-routes/',
    path: '/trips/trips-routes/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTripsTripsRoutesTableRoute =
  LayoutTripsTripsRoutesTableRouteImport.update({
    id: '/trips/trips-routes/table',
    path: '/trips/trips-routes/table',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/trips/trips-routes/table.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutStationsStationStationIdRoute =
  LayoutStationsStationStationIdRouteImport.update({
    id: '/stations/station/$stationId',
    path: '/stations/station/$stationId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStationsPathwaysFlowRoute =
  LayoutStationsPathwaysFlowRouteImport.update({
    id: '/flow',
    path: '/flow',
    getParentRoute: () => LayoutStationsPathwaysRoute,
  } as any)
const LayoutStationsPartsTableRoute =
  LayoutStationsPartsTableRouteImport.update({
    id: '/table',
    path: '/table',
    getParentRoute: () => LayoutStationsPartsRoute,
  } as any)
const LayoutStationsPartsMapRoute = LayoutStationsPartsMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => LayoutStationsPartsRoute,
} as any)
const LayoutRoutesRouteRouteIdRoute =
  LayoutRoutesRouteRouteIdRouteImport.update({
    id: '/routes/route/$routeId',
    path: '/routes/route/$routeId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStationsStationStationIdIndexRoute =
  LayoutStationsStationStationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStationsStationStationIdRoute,
  } as any)
const LayoutStationsPathwaysFlowIndexRoute =
  LayoutStationsPathwaysFlowIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStationsPathwaysFlowRoute,
  } as any)
const LayoutRoutesRouteRouteIdIndexRoute =
  LayoutRoutesRouteRouteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutRoutesRouteRouteIdRoute,
  } as any)
const LayoutStationsStationStationIdPartsRoute =
  LayoutStationsStationStationIdPartsRouteImport.update({
    id: '/parts',
    path: '/parts',
    getParentRoute: () => LayoutStationsStationStationIdRoute,
  } as any)
const LayoutStationsStationStationIdInfoRoute =
  LayoutStationsStationStationIdInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => LayoutStationsStationStationIdRoute,
  } as any)
const LayoutStationsPathwaysTableStartRoute =
  LayoutStationsPathwaysTableStartRouteImport.update({
    id: '/table/start',
    path: '/table/start',
    getParentRoute: () => LayoutStationsPathwaysRoute,
  } as any)
const LayoutStationsPathwaysTableEndRoute =
  LayoutStationsPathwaysTableEndRouteImport.update({
    id: '/table/end',
    path: '/table/end',
    getParentRoute: () => LayoutStationsPathwaysRoute,
  } as any)
const LayoutStationsPathwaysMapTimeIntervalRoute =
  LayoutStationsPathwaysMapTimeIntervalRouteImport.update({
    id: '/map/timeInterval',
    path: '/map/timeInterval',
    getParentRoute: () => LayoutStationsPathwaysRoute,
  } as any)
const LayoutStationsPathwaysMapPathwayTypesRoute =
  LayoutStationsPathwaysMapPathwayTypesRouteImport.update({
    id: '/map/pathwayTypes',
    path: '/map/pathwayTypes',
    getParentRoute: () => LayoutStationsPathwaysRoute,
  } as any)
const LayoutStationsPathwaysMapDirectionalRoute =
  LayoutStationsPathwaysMapDirectionalRouteImport.update({
    id: '/map/directional',
    path: '/map/directional',
    getParentRoute: () => LayoutStationsPathwaysRoute,
  } as any)
const LayoutStationsPathwaysFlowRadialRoute =
  LayoutStationsPathwaysFlowRadialRouteImport.update({
    id: '/radial',
    path: '/radial',
    getParentRoute: () => LayoutStationsPathwaysFlowRoute,
  } as any)
const LayoutStationsPathwaysFlowColumnRoute =
  LayoutStationsPathwaysFlowColumnRouteImport.update({
    id: '/column',
    path: '/column',
    getParentRoute: () => LayoutStationsPathwaysFlowRoute,
  } as any)
const LayoutRoutesRouteRouteIdTripsRoute =
  LayoutRoutesRouteRouteIdTripsRouteImport.update({
    id: '/trips',
    path: '/trips',
    getParentRoute: () => LayoutRoutesRouteRouteIdRoute,
  } as any)
const LayoutRoutesRouteRouteIdInfoRoute =
  LayoutRoutesRouteRouteIdInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => LayoutRoutesRouteRouteIdRoute,
  } as any)
const LayoutStationsStationStationIdPartsIndexRoute =
  LayoutStationsStationStationIdPartsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStationsStationStationIdPartsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/routes/info': typeof LayoutRoutesInfoRoute
  '/routes/map': typeof LayoutRoutesMapRoute
  '/routes/service': typeof LayoutRoutesServiceRoute
  '/routes/table': typeof LayoutRoutesTableRoute
  '/routes/trips': typeof LayoutRoutesTripsRoute
  '/stations/flow': typeof LayoutStationsFlowRoute
  '/stations/info': typeof LayoutStationsInfoRoute
  '/stations/map': typeof LayoutStationsMapRoute
  '/stations/parts': typeof LayoutStationsPartsRouteWithChildren
  '/stations/pathways': typeof LayoutStationsPathwaysRouteWithChildren
  '/stations/table': typeof LayoutStationsTableRoute
  '/stops/map': typeof LayoutStopsMapRoute
  '/stops/table': typeof LayoutStopsTableRoute
  '/trips/table': typeof LayoutTripsTableRoute
  '/export/': typeof LayoutExportIndexRoute
  '/routes/': typeof LayoutRoutesIndexRoute
  '/stations/': typeof LayoutStationsIndexRoute
  '/stops/': typeof LayoutStopsIndexRoute
  '/trips/': typeof LayoutTripsIndexRoute
  '/routes/route/$routeId': typeof LayoutRoutesRouteRouteIdRouteWithChildren
  '/stations/parts/map': typeof LayoutStationsPartsMapRoute
  '/stations/parts/table': typeof LayoutStationsPartsTableRoute
  '/stations/pathways/flow': typeof LayoutStationsPathwaysFlowRouteWithChildren
  '/stations/station/$stationId': typeof LayoutStationsStationStationIdRouteWithChildren
  '/trips/trips-routes/table': typeof LayoutTripsTripsRoutesTableRoute
  '/trips/trips-routes/': typeof LayoutTripsTripsRoutesIndexRoute
  '/routes/route/$routeId/info': typeof LayoutRoutesRouteRouteIdInfoRoute
  '/routes/route/$routeId/trips': typeof LayoutRoutesRouteRouteIdTripsRoute
  '/stations/pathways/flow/column': typeof LayoutStationsPathwaysFlowColumnRoute
  '/stations/pathways/flow/radial': typeof LayoutStationsPathwaysFlowRadialRoute
  '/stations/pathways/map/directional': typeof LayoutStationsPathwaysMapDirectionalRoute
  '/stations/pathways/map/pathwayTypes': typeof LayoutStationsPathwaysMapPathwayTypesRoute
  '/stations/pathways/map/timeInterval': typeof LayoutStationsPathwaysMapTimeIntervalRoute
  '/stations/pathways/table/end': typeof LayoutStationsPathwaysTableEndRoute
  '/stations/pathways/table/start': typeof LayoutStationsPathwaysTableStartRoute
  '/stations/station/$stationId/info': typeof LayoutStationsStationStationIdInfoRoute
  '/stations/station/$stationId/parts': typeof LayoutStationsStationStationIdPartsRouteWithChildren
  '/routes/route/$routeId/': typeof LayoutRoutesRouteRouteIdIndexRoute
  '/stations/pathways/flow/': typeof LayoutStationsPathwaysFlowIndexRoute
  '/stations/station/$stationId/': typeof LayoutStationsStationStationIdIndexRoute
  '/stations/station/$stationId/parts/': typeof LayoutStationsStationStationIdPartsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/routes/info': typeof LayoutRoutesInfoRoute
  '/routes/map': typeof LayoutRoutesMapRoute
  '/routes/service': typeof LayoutRoutesServiceRoute
  '/routes/table': typeof LayoutRoutesTableRoute
  '/routes/trips': typeof LayoutRoutesTripsRoute
  '/stations/flow': typeof LayoutStationsFlowRoute
  '/stations/info': typeof LayoutStationsInfoRoute
  '/stations/map': typeof LayoutStationsMapRoute
  '/stations/parts': typeof LayoutStationsPartsRouteWithChildren
  '/stations/pathways': typeof LayoutStationsPathwaysRouteWithChildren
  '/stations/table': typeof LayoutStationsTableRoute
  '/stops/map': typeof LayoutStopsMapRoute
  '/stops/table': typeof LayoutStopsTableRoute
  '/trips/table': typeof LayoutTripsTableRoute
  '/export': typeof LayoutExportIndexRoute
  '/routes': typeof LayoutRoutesIndexRoute
  '/stations': typeof LayoutStationsIndexRoute
  '/stops': typeof LayoutStopsIndexRoute
  '/trips': typeof LayoutTripsIndexRoute
  '/stations/parts/map': typeof LayoutStationsPartsMapRoute
  '/stations/parts/table': typeof LayoutStationsPartsTableRoute
  '/trips/trips-routes/table': typeof LayoutTripsTripsRoutesTableRoute
  '/trips/trips-routes': typeof LayoutTripsTripsRoutesIndexRoute
  '/routes/route/$routeId/info': typeof LayoutRoutesRouteRouteIdInfoRoute
  '/routes/route/$routeId/trips': typeof LayoutRoutesRouteRouteIdTripsRoute
  '/stations/pathways/flow/column': typeof LayoutStationsPathwaysFlowColumnRoute
  '/stations/pathways/flow/radial': typeof LayoutStationsPathwaysFlowRadialRoute
  '/stations/pathways/map/directional': typeof LayoutStationsPathwaysMapDirectionalRoute
  '/stations/pathways/map/pathwayTypes': typeof LayoutStationsPathwaysMapPathwayTypesRoute
  '/stations/pathways/map/timeInterval': typeof LayoutStationsPathwaysMapTimeIntervalRoute
  '/stations/pathways/table/end': typeof LayoutStationsPathwaysTableEndRoute
  '/stations/pathways/table/start': typeof LayoutStationsPathwaysTableStartRoute
  '/stations/station/$stationId/info': typeof LayoutStationsStationStationIdInfoRoute
  '/routes/route/$routeId': typeof LayoutRoutesRouteRouteIdIndexRoute
  '/stations/pathways/flow': typeof LayoutStationsPathwaysFlowIndexRoute
  '/stations/station/$stationId': typeof LayoutStationsStationStationIdIndexRoute
  '/stations/station/$stationId/parts': typeof LayoutStationsStationStationIdPartsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/routes/info': typeof LayoutRoutesInfoRoute
  '/_layout/routes/map': typeof LayoutRoutesMapRoute
  '/_layout/routes/service': typeof LayoutRoutesServiceRoute
  '/_layout/routes/table': typeof LayoutRoutesTableRoute
  '/_layout/routes/trips': typeof LayoutRoutesTripsRoute
  '/_layout/stations/flow': typeof LayoutStationsFlowRoute
  '/_layout/stations/info': typeof LayoutStationsInfoRoute
  '/_layout/stations/map': typeof LayoutStationsMapRoute
  '/_layout/stations/parts': typeof LayoutStationsPartsRouteWithChildren
  '/_layout/stations/pathways': typeof LayoutStationsPathwaysRouteWithChildren
  '/_layout/stations/table': typeof LayoutStationsTableRoute
  '/_layout/stops/map': typeof LayoutStopsMapRoute
  '/_layout/stops/table': typeof LayoutStopsTableRoute
  '/_layout/trips/table': typeof LayoutTripsTableRoute
  '/_layout/export/': typeof LayoutExportIndexRoute
  '/_layout/routes/': typeof LayoutRoutesIndexRoute
  '/_layout/stations/': typeof LayoutStationsIndexRoute
  '/_layout/stops/': typeof LayoutStopsIndexRoute
  '/_layout/trips/': typeof LayoutTripsIndexRoute
  '/_layout/routes/route/$routeId': typeof LayoutRoutesRouteRouteIdRouteWithChildren
  '/_layout/stations/parts/map': typeof LayoutStationsPartsMapRoute
  '/_layout/stations/parts/table': typeof LayoutStationsPartsTableRoute
  '/_layout/stations/pathways/flow': typeof LayoutStationsPathwaysFlowRouteWithChildren
  '/_layout/stations/station/$stationId': typeof LayoutStationsStationStationIdRouteWithChildren
  '/_layout/trips/trips-routes/table': typeof LayoutTripsTripsRoutesTableRoute
  '/_layout/trips/trips-routes/': typeof LayoutTripsTripsRoutesIndexRoute
  '/_layout/routes/route/$routeId/info': typeof LayoutRoutesRouteRouteIdInfoRoute
  '/_layout/routes/route/$routeId/trips': typeof LayoutRoutesRouteRouteIdTripsRoute
  '/_layout/stations/pathways/flow/column': typeof LayoutStationsPathwaysFlowColumnRoute
  '/_layout/stations/pathways/flow/radial': typeof LayoutStationsPathwaysFlowRadialRoute
  '/_layout/stations/pathways/map/directional': typeof LayoutStationsPathwaysMapDirectionalRoute
  '/_layout/stations/pathways/map/pathwayTypes': typeof LayoutStationsPathwaysMapPathwayTypesRoute
  '/_layout/stations/pathways/map/timeInterval': typeof LayoutStationsPathwaysMapTimeIntervalRoute
  '/_layout/stations/pathways/table/end': typeof LayoutStationsPathwaysTableEndRoute
  '/_layout/stations/pathways/table/start': typeof LayoutStationsPathwaysTableStartRoute
  '/_layout/stations/station/$stationId/info': typeof LayoutStationsStationStationIdInfoRoute
  '/_layout/stations/station/$stationId/parts': typeof LayoutStationsStationStationIdPartsRouteWithChildren
  '/_layout/routes/route/$routeId/': typeof LayoutRoutesRouteRouteIdIndexRoute
  '/_layout/stations/pathways/flow/': typeof LayoutStationsPathwaysFlowIndexRoute
  '/_layout/stations/station/$stationId/': typeof LayoutStationsStationStationIdIndexRoute
  '/_layout/stations/station/$stationId/parts/': typeof LayoutStationsStationStationIdPartsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/routes/info'
    | '/routes/map'
    | '/routes/service'
    | '/routes/table'
    | '/routes/trips'
    | '/stations/flow'
    | '/stations/info'
    | '/stations/map'
    | '/stations/parts'
    | '/stations/pathways'
    | '/stations/table'
    | '/stops/map'
    | '/stops/table'
    | '/trips/table'
    | '/export/'
    | '/routes/'
    | '/stations/'
    | '/stops/'
    | '/trips/'
    | '/routes/route/$routeId'
    | '/stations/parts/map'
    | '/stations/parts/table'
    | '/stations/pathways/flow'
    | '/stations/station/$stationId'
    | '/trips/trips-routes/table'
    | '/trips/trips-routes/'
    | '/routes/route/$routeId/info'
    | '/routes/route/$routeId/trips'
    | '/stations/pathways/flow/column'
    | '/stations/pathways/flow/radial'
    | '/stations/pathways/map/directional'
    | '/stations/pathways/map/pathwayTypes'
    | '/stations/pathways/map/timeInterval'
    | '/stations/pathways/table/end'
    | '/stations/pathways/table/start'
    | '/stations/station/$stationId/info'
    | '/stations/station/$stationId/parts'
    | '/routes/route/$routeId/'
    | '/stations/pathways/flow/'
    | '/stations/station/$stationId/'
    | '/stations/station/$stationId/parts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/routes/info'
    | '/routes/map'
    | '/routes/service'
    | '/routes/table'
    | '/routes/trips'
    | '/stations/flow'
    | '/stations/info'
    | '/stations/map'
    | '/stations/parts'
    | '/stations/pathways'
    | '/stations/table'
    | '/stops/map'
    | '/stops/table'
    | '/trips/table'
    | '/export'
    | '/routes'
    | '/stations'
    | '/stops'
    | '/trips'
    | '/stations/parts/map'
    | '/stations/parts/table'
    | '/trips/trips-routes/table'
    | '/trips/trips-routes'
    | '/routes/route/$routeId/info'
    | '/routes/route/$routeId/trips'
    | '/stations/pathways/flow/column'
    | '/stations/pathways/flow/radial'
    | '/stations/pathways/map/directional'
    | '/stations/pathways/map/pathwayTypes'
    | '/stations/pathways/map/timeInterval'
    | '/stations/pathways/table/end'
    | '/stations/pathways/table/start'
    | '/stations/station/$stationId/info'
    | '/routes/route/$routeId'
    | '/stations/pathways/flow'
    | '/stations/station/$stationId'
    | '/stations/station/$stationId/parts'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/_layout/routes/info'
    | '/_layout/routes/map'
    | '/_layout/routes/service'
    | '/_layout/routes/table'
    | '/_layout/routes/trips'
    | '/_layout/stations/flow'
    | '/_layout/stations/info'
    | '/_layout/stations/map'
    | '/_layout/stations/parts'
    | '/_layout/stations/pathways'
    | '/_layout/stations/table'
    | '/_layout/stops/map'
    | '/_layout/stops/table'
    | '/_layout/trips/table'
    | '/_layout/export/'
    | '/_layout/routes/'
    | '/_layout/stations/'
    | '/_layout/stops/'
    | '/_layout/trips/'
    | '/_layout/routes/route/$routeId'
    | '/_layout/stations/parts/map'
    | '/_layout/stations/parts/table'
    | '/_layout/stations/pathways/flow'
    | '/_layout/stations/station/$stationId'
    | '/_layout/trips/trips-routes/table'
    | '/_layout/trips/trips-routes/'
    | '/_layout/routes/route/$routeId/info'
    | '/_layout/routes/route/$routeId/trips'
    | '/_layout/stations/pathways/flow/column'
    | '/_layout/stations/pathways/flow/radial'
    | '/_layout/stations/pathways/map/directional'
    | '/_layout/stations/pathways/map/pathwayTypes'
    | '/_layout/stations/pathways/map/timeInterval'
    | '/_layout/stations/pathways/table/end'
    | '/_layout/stations/pathways/table/start'
    | '/_layout/stations/station/$stationId/info'
    | '/_layout/stations/station/$stationId/parts'
    | '/_layout/routes/route/$routeId/'
    | '/_layout/stations/pathways/flow/'
    | '/_layout/stations/station/$stationId/'
    | '/_layout/stations/station/$stationId/parts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/trips/': {
      id: '/_layout/trips/'
      path: '/trips'
      fullPath: '/trips/'
      preLoaderRoute: typeof LayoutTripsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stops/': {
      id: '/_layout/stops/'
      path: '/stops'
      fullPath: '/stops/'
      preLoaderRoute: typeof LayoutStopsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/': {
      id: '/_layout/stations/'
      path: '/stations'
      fullPath: '/stations/'
      preLoaderRoute: typeof LayoutStationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/routes/': {
      id: '/_layout/routes/'
      path: '/routes'
      fullPath: '/routes/'
      preLoaderRoute: typeof LayoutRoutesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/export/': {
      id: '/_layout/export/'
      path: '/export'
      fullPath: '/export/'
      preLoaderRoute: typeof LayoutExportIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/trips/table': {
      id: '/_layout/trips/table'
      path: '/trips/table'
      fullPath: '/trips/table'
      preLoaderRoute: typeof LayoutTripsTableRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stops/table': {
      id: '/_layout/stops/table'
      path: '/stops/table'
      fullPath: '/stops/table'
      preLoaderRoute: typeof LayoutStopsTableRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stops/map': {
      id: '/_layout/stops/map'
      path: '/stops/map'
      fullPath: '/stops/map'
      preLoaderRoute: typeof LayoutStopsMapRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/table': {
      id: '/_layout/stations/table'
      path: '/stations/table'
      fullPath: '/stations/table'
      preLoaderRoute: typeof LayoutStationsTableRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/pathways': {
      id: '/_layout/stations/pathways'
      path: '/stations/pathways'
      fullPath: '/stations/pathways'
      preLoaderRoute: typeof LayoutStationsPathwaysRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/parts': {
      id: '/_layout/stations/parts'
      path: '/stations/parts'
      fullPath: '/stations/parts'
      preLoaderRoute: typeof LayoutStationsPartsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/map': {
      id: '/_layout/stations/map'
      path: '/stations/map'
      fullPath: '/stations/map'
      preLoaderRoute: typeof LayoutStationsMapRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/info': {
      id: '/_layout/stations/info'
      path: '/stations/info'
      fullPath: '/stations/info'
      preLoaderRoute: typeof LayoutStationsInfoRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/flow': {
      id: '/_layout/stations/flow'
      path: '/stations/flow'
      fullPath: '/stations/flow'
      preLoaderRoute: typeof LayoutStationsFlowRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/routes/trips': {
      id: '/_layout/routes/trips'
      path: '/routes/trips'
      fullPath: '/routes/trips'
      preLoaderRoute: typeof LayoutRoutesTripsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/routes/table': {
      id: '/_layout/routes/table'
      path: '/routes/table'
      fullPath: '/routes/table'
      preLoaderRoute: typeof LayoutRoutesTableRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/routes/service': {
      id: '/_layout/routes/service'
      path: '/routes/service'
      fullPath: '/routes/service'
      preLoaderRoute: typeof LayoutRoutesServiceRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/routes/map': {
      id: '/_layout/routes/map'
      path: '/routes/map'
      fullPath: '/routes/map'
      preLoaderRoute: typeof LayoutRoutesMapRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/routes/info': {
      id: '/_layout/routes/info'
      path: '/routes/info'
      fullPath: '/routes/info'
      preLoaderRoute: typeof LayoutRoutesInfoRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/trips/trips-routes/': {
      id: '/_layout/trips/trips-routes/'
      path: '/trips/trips-routes'
      fullPath: '/trips/trips-routes/'
      preLoaderRoute: typeof LayoutTripsTripsRoutesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/trips/trips-routes/table': {
      id: '/_layout/trips/trips-routes/table'
      path: '/trips/trips-routes/table'
      fullPath: '/trips/trips-routes/table'
      preLoaderRoute: typeof LayoutTripsTripsRoutesTableRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/station/$stationId': {
      id: '/_layout/stations/station/$stationId'
      path: '/stations/station/$stationId'
      fullPath: '/stations/station/$stationId'
      preLoaderRoute: typeof LayoutStationsStationStationIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/pathways/flow': {
      id: '/_layout/stations/pathways/flow'
      path: '/flow'
      fullPath: '/stations/pathways/flow'
      preLoaderRoute: typeof LayoutStationsPathwaysFlowRouteImport
      parentRoute: typeof LayoutStationsPathwaysRoute
    }
    '/_layout/stations/parts/table': {
      id: '/_layout/stations/parts/table'
      path: '/table'
      fullPath: '/stations/parts/table'
      preLoaderRoute: typeof LayoutStationsPartsTableRouteImport
      parentRoute: typeof LayoutStationsPartsRoute
    }
    '/_layout/stations/parts/map': {
      id: '/_layout/stations/parts/map'
      path: '/map'
      fullPath: '/stations/parts/map'
      preLoaderRoute: typeof LayoutStationsPartsMapRouteImport
      parentRoute: typeof LayoutStationsPartsRoute
    }
    '/_layout/routes/route/$routeId': {
      id: '/_layout/routes/route/$routeId'
      path: '/routes/route/$routeId'
      fullPath: '/routes/route/$routeId'
      preLoaderRoute: typeof LayoutRoutesRouteRouteIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/stations/station/$stationId/': {
      id: '/_layout/stations/station/$stationId/'
      path: '/'
      fullPath: '/stations/station/$stationId/'
      preLoaderRoute: typeof LayoutStationsStationStationIdIndexRouteImport
      parentRoute: typeof LayoutStationsStationStationIdRoute
    }
    '/_layout/stations/pathways/flow/': {
      id: '/_layout/stations/pathways/flow/'
      path: '/'
      fullPath: '/stations/pathways/flow/'
      preLoaderRoute: typeof LayoutStationsPathwaysFlowIndexRouteImport
      parentRoute: typeof LayoutStationsPathwaysFlowRoute
    }
    '/_layout/routes/route/$routeId/': {
      id: '/_layout/routes/route/$routeId/'
      path: '/'
      fullPath: '/routes/route/$routeId/'
      preLoaderRoute: typeof LayoutRoutesRouteRouteIdIndexRouteImport
      parentRoute: typeof LayoutRoutesRouteRouteIdRoute
    }
    '/_layout/stations/station/$stationId/parts': {
      id: '/_layout/stations/station/$stationId/parts'
      path: '/parts'
      fullPath: '/stations/station/$stationId/parts'
      preLoaderRoute: typeof LayoutStationsStationStationIdPartsRouteImport
      parentRoute: typeof LayoutStationsStationStationIdRoute
    }
    '/_layout/stations/station/$stationId/info': {
      id: '/_layout/stations/station/$stationId/info'
      path: '/info'
      fullPath: '/stations/station/$stationId/info'
      preLoaderRoute: typeof LayoutStationsStationStationIdInfoRouteImport
      parentRoute: typeof LayoutStationsStationStationIdRoute
    }
    '/_layout/stations/pathways/table/start': {
      id: '/_layout/stations/pathways/table/start'
      path: '/table/start'
      fullPath: '/stations/pathways/table/start'
      preLoaderRoute: typeof LayoutStationsPathwaysTableStartRouteImport
      parentRoute: typeof LayoutStationsPathwaysRoute
    }
    '/_layout/stations/pathways/table/end': {
      id: '/_layout/stations/pathways/table/end'
      path: '/table/end'
      fullPath: '/stations/pathways/table/end'
      preLoaderRoute: typeof LayoutStationsPathwaysTableEndRouteImport
      parentRoute: typeof LayoutStationsPathwaysRoute
    }
    '/_layout/stations/pathways/map/timeInterval': {
      id: '/_layout/stations/pathways/map/timeInterval'
      path: '/map/timeInterval'
      fullPath: '/stations/pathways/map/timeInterval'
      preLoaderRoute: typeof LayoutStationsPathwaysMapTimeIntervalRouteImport
      parentRoute: typeof LayoutStationsPathwaysRoute
    }
    '/_layout/stations/pathways/map/pathwayTypes': {
      id: '/_layout/stations/pathways/map/pathwayTypes'
      path: '/map/pathwayTypes'
      fullPath: '/stations/pathways/map/pathwayTypes'
      preLoaderRoute: typeof LayoutStationsPathwaysMapPathwayTypesRouteImport
      parentRoute: typeof LayoutStationsPathwaysRoute
    }
    '/_layout/stations/pathways/map/directional': {
      id: '/_layout/stations/pathways/map/directional'
      path: '/map/directional'
      fullPath: '/stations/pathways/map/directional'
      preLoaderRoute: typeof LayoutStationsPathwaysMapDirectionalRouteImport
      parentRoute: typeof LayoutStationsPathwaysRoute
    }
    '/_layout/stations/pathways/flow/radial': {
      id: '/_layout/stations/pathways/flow/radial'
      path: '/radial'
      fullPath: '/stations/pathways/flow/radial'
      preLoaderRoute: typeof LayoutStationsPathwaysFlowRadialRouteImport
      parentRoute: typeof LayoutStationsPathwaysFlowRoute
    }
    '/_layout/stations/pathways/flow/column': {
      id: '/_layout/stations/pathways/flow/column'
      path: '/column'
      fullPath: '/stations/pathways/flow/column'
      preLoaderRoute: typeof LayoutStationsPathwaysFlowColumnRouteImport
      parentRoute: typeof LayoutStationsPathwaysFlowRoute
    }
    '/_layout/routes/route/$routeId/trips': {
      id: '/_layout/routes/route/$routeId/trips'
      path: '/trips'
      fullPath: '/routes/route/$routeId/trips'
      preLoaderRoute: typeof LayoutRoutesRouteRouteIdTripsRouteImport
      parentRoute: typeof LayoutRoutesRouteRouteIdRoute
    }
    '/_layout/routes/route/$routeId/info': {
      id: '/_layout/routes/route/$routeId/info'
      path: '/info'
      fullPath: '/routes/route/$routeId/info'
      preLoaderRoute: typeof LayoutRoutesRouteRouteIdInfoRouteImport
      parentRoute: typeof LayoutRoutesRouteRouteIdRoute
    }
    '/_layout/stations/station/$stationId/parts/': {
      id: '/_layout/stations/station/$stationId/parts/'
      path: '/'
      fullPath: '/stations/station/$stationId/parts/'
      preLoaderRoute: typeof LayoutStationsStationStationIdPartsIndexRouteImport
      parentRoute: typeof LayoutStationsStationStationIdPartsRoute
    }
  }
}

interface LayoutStationsPartsRouteChildren {
  LayoutStationsPartsMapRoute: typeof LayoutStationsPartsMapRoute
  LayoutStationsPartsTableRoute: typeof LayoutStationsPartsTableRoute
}

const LayoutStationsPartsRouteChildren: LayoutStationsPartsRouteChildren = {
  LayoutStationsPartsMapRoute: LayoutStationsPartsMapRoute,
  LayoutStationsPartsTableRoute: LayoutStationsPartsTableRoute,
}

const LayoutStationsPartsRouteWithChildren =
  LayoutStationsPartsRoute._addFileChildren(LayoutStationsPartsRouteChildren)

interface LayoutStationsPathwaysFlowRouteChildren {
  LayoutStationsPathwaysFlowColumnRoute: typeof LayoutStationsPathwaysFlowColumnRoute
  LayoutStationsPathwaysFlowRadialRoute: typeof LayoutStationsPathwaysFlowRadialRoute
  LayoutStationsPathwaysFlowIndexRoute: typeof LayoutStationsPathwaysFlowIndexRoute
}

const LayoutStationsPathwaysFlowRouteChildren: LayoutStationsPathwaysFlowRouteChildren =
  {
    LayoutStationsPathwaysFlowColumnRoute:
      LayoutStationsPathwaysFlowColumnRoute,
    LayoutStationsPathwaysFlowRadialRoute:
      LayoutStationsPathwaysFlowRadialRoute,
    LayoutStationsPathwaysFlowIndexRoute: LayoutStationsPathwaysFlowIndexRoute,
  }

const LayoutStationsPathwaysFlowRouteWithChildren =
  LayoutStationsPathwaysFlowRoute._addFileChildren(
    LayoutStationsPathwaysFlowRouteChildren,
  )

interface LayoutStationsPathwaysRouteChildren {
  LayoutStationsPathwaysFlowRoute: typeof LayoutStationsPathwaysFlowRouteWithChildren
  LayoutStationsPathwaysMapDirectionalRoute: typeof LayoutStationsPathwaysMapDirectionalRoute
  LayoutStationsPathwaysMapPathwayTypesRoute: typeof LayoutStationsPathwaysMapPathwayTypesRoute
  LayoutStationsPathwaysMapTimeIntervalRoute: typeof LayoutStationsPathwaysMapTimeIntervalRoute
  LayoutStationsPathwaysTableEndRoute: typeof LayoutStationsPathwaysTableEndRoute
  LayoutStationsPathwaysTableStartRoute: typeof LayoutStationsPathwaysTableStartRoute
}

const LayoutStationsPathwaysRouteChildren: LayoutStationsPathwaysRouteChildren =
  {
    LayoutStationsPathwaysFlowRoute:
      LayoutStationsPathwaysFlowRouteWithChildren,
    LayoutStationsPathwaysMapDirectionalRoute:
      LayoutStationsPathwaysMapDirectionalRoute,
    LayoutStationsPathwaysMapPathwayTypesRoute:
      LayoutStationsPathwaysMapPathwayTypesRoute,
    LayoutStationsPathwaysMapTimeIntervalRoute:
      LayoutStationsPathwaysMapTimeIntervalRoute,
    LayoutStationsPathwaysTableEndRoute: LayoutStationsPathwaysTableEndRoute,
    LayoutStationsPathwaysTableStartRoute:
      LayoutStationsPathwaysTableStartRoute,
  }

const LayoutStationsPathwaysRouteWithChildren =
  LayoutStationsPathwaysRoute._addFileChildren(
    LayoutStationsPathwaysRouteChildren,
  )

interface LayoutRoutesRouteRouteIdRouteChildren {
  LayoutRoutesRouteRouteIdInfoRoute: typeof LayoutRoutesRouteRouteIdInfoRoute
  LayoutRoutesRouteRouteIdTripsRoute: typeof LayoutRoutesRouteRouteIdTripsRoute
  LayoutRoutesRouteRouteIdIndexRoute: typeof LayoutRoutesRouteRouteIdIndexRoute
}

const LayoutRoutesRouteRouteIdRouteChildren: LayoutRoutesRouteRouteIdRouteChildren =
  {
    LayoutRoutesRouteRouteIdInfoRoute: LayoutRoutesRouteRouteIdInfoRoute,
    LayoutRoutesRouteRouteIdTripsRoute: LayoutRoutesRouteRouteIdTripsRoute,
    LayoutRoutesRouteRouteIdIndexRoute: LayoutRoutesRouteRouteIdIndexRoute,
  }

const LayoutRoutesRouteRouteIdRouteWithChildren =
  LayoutRoutesRouteRouteIdRoute._addFileChildren(
    LayoutRoutesRouteRouteIdRouteChildren,
  )

interface LayoutStationsStationStationIdPartsRouteChildren {
  LayoutStationsStationStationIdPartsIndexRoute: typeof LayoutStationsStationStationIdPartsIndexRoute
}

const LayoutStationsStationStationIdPartsRouteChildren: LayoutStationsStationStationIdPartsRouteChildren =
  {
    LayoutStationsStationStationIdPartsIndexRoute:
      LayoutStationsStationStationIdPartsIndexRoute,
  }

const LayoutStationsStationStationIdPartsRouteWithChildren =
  LayoutStationsStationStationIdPartsRoute._addFileChildren(
    LayoutStationsStationStationIdPartsRouteChildren,
  )

interface LayoutStationsStationStationIdRouteChildren {
  LayoutStationsStationStationIdInfoRoute: typeof LayoutStationsStationStationIdInfoRoute
  LayoutStationsStationStationIdPartsRoute: typeof LayoutStationsStationStationIdPartsRouteWithChildren
  LayoutStationsStationStationIdIndexRoute: typeof LayoutStationsStationStationIdIndexRoute
}

const LayoutStationsStationStationIdRouteChildren: LayoutStationsStationStationIdRouteChildren =
  {
    LayoutStationsStationStationIdInfoRoute:
      LayoutStationsStationStationIdInfoRoute,
    LayoutStationsStationStationIdPartsRoute:
      LayoutStationsStationStationIdPartsRouteWithChildren,
    LayoutStationsStationStationIdIndexRoute:
      LayoutStationsStationStationIdIndexRoute,
  }

const LayoutStationsStationStationIdRouteWithChildren =
  LayoutStationsStationStationIdRoute._addFileChildren(
    LayoutStationsStationStationIdRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutRoutesInfoRoute: typeof LayoutRoutesInfoRoute
  LayoutRoutesMapRoute: typeof LayoutRoutesMapRoute
  LayoutRoutesServiceRoute: typeof LayoutRoutesServiceRoute
  LayoutRoutesTableRoute: typeof LayoutRoutesTableRoute
  LayoutRoutesTripsRoute: typeof LayoutRoutesTripsRoute
  LayoutStationsFlowRoute: typeof LayoutStationsFlowRoute
  LayoutStationsInfoRoute: typeof LayoutStationsInfoRoute
  LayoutStationsMapRoute: typeof LayoutStationsMapRoute
  LayoutStationsPartsRoute: typeof LayoutStationsPartsRouteWithChildren
  LayoutStationsPathwaysRoute: typeof LayoutStationsPathwaysRouteWithChildren
  LayoutStationsTableRoute: typeof LayoutStationsTableRoute
  LayoutStopsMapRoute: typeof LayoutStopsMapRoute
  LayoutStopsTableRoute: typeof LayoutStopsTableRoute
  LayoutTripsTableRoute: typeof LayoutTripsTableRoute
  LayoutExportIndexRoute: typeof LayoutExportIndexRoute
  LayoutRoutesIndexRoute: typeof LayoutRoutesIndexRoute
  LayoutStationsIndexRoute: typeof LayoutStationsIndexRoute
  LayoutStopsIndexRoute: typeof LayoutStopsIndexRoute
  LayoutTripsIndexRoute: typeof LayoutTripsIndexRoute
  LayoutRoutesRouteRouteIdRoute: typeof LayoutRoutesRouteRouteIdRouteWithChildren
  LayoutStationsStationStationIdRoute: typeof LayoutStationsStationStationIdRouteWithChildren
  LayoutTripsTripsRoutesTableRoute: typeof LayoutTripsTripsRoutesTableRoute
  LayoutTripsTripsRoutesIndexRoute: typeof LayoutTripsTripsRoutesIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutRoutesInfoRoute: LayoutRoutesInfoRoute,
  LayoutRoutesMapRoute: LayoutRoutesMapRoute,
  LayoutRoutesServiceRoute: LayoutRoutesServiceRoute,
  LayoutRoutesTableRoute: LayoutRoutesTableRoute,
  LayoutRoutesTripsRoute: LayoutRoutesTripsRoute,
  LayoutStationsFlowRoute: LayoutStationsFlowRoute,
  LayoutStationsInfoRoute: LayoutStationsInfoRoute,
  LayoutStationsMapRoute: LayoutStationsMapRoute,
  LayoutStationsPartsRoute: LayoutStationsPartsRouteWithChildren,
  LayoutStationsPathwaysRoute: LayoutStationsPathwaysRouteWithChildren,
  LayoutStationsTableRoute: LayoutStationsTableRoute,
  LayoutStopsMapRoute: LayoutStopsMapRoute,
  LayoutStopsTableRoute: LayoutStopsTableRoute,
  LayoutTripsTableRoute: LayoutTripsTableRoute,
  LayoutExportIndexRoute: LayoutExportIndexRoute,
  LayoutRoutesIndexRoute: LayoutRoutesIndexRoute,
  LayoutStationsIndexRoute: LayoutStationsIndexRoute,
  LayoutStopsIndexRoute: LayoutStopsIndexRoute,
  LayoutTripsIndexRoute: LayoutTripsIndexRoute,
  LayoutRoutesRouteRouteIdRoute: LayoutRoutesRouteRouteIdRouteWithChildren,
  LayoutStationsStationStationIdRoute:
    LayoutStationsStationStationIdRouteWithChildren,
  LayoutTripsTripsRoutesTableRoute: LayoutTripsTripsRoutesTableRoute,
  LayoutTripsTripsRoutesIndexRoute: LayoutTripsTripsRoutesIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
